/*
 * Holds hover, extra-slide, and swatch-overlay images inside
 * <template data-deferred-card-media> until the first real interaction,
 * then stamps them into the document. Off-screen images still honor
 * loading="lazy". Safe to include more than once.
 *
 * After unlock, any element added under body is stamped. That covers
 * header search, homepage tabs fetched on click, merch Load More, and a
 * filter or sort that swaps in a new grid already full of cards. Watching
 * the grid itself misses those cards: they are not added after observation
 * starts.
 *
 * The native search fallback only flips .abt-237-native-wrapper from
 * display:none to display:block. Those templates were skipped while hidden,
 * and a style change adds no nodes, so that wrapper is stamped when shown.
 */
(function () {
  if (window.__ceDeferredCardImages) return;
  window.__ceDeferredCardImages = { unlocked: false };

  var state = window.__ceDeferredCardImages;
  var events = ["pointerdown", "pointerover", "wheel", "scroll", "keydown"];
  var searchWraps = ".abt-237-native-wrapper, .abt-237-ce-wrapper";

  function hiddenSearchCopy(tpl) {
    var wrap = tpl.closest(searchWraps);
    return wrap ? window.getComputedStyle(wrap).display === "none" : false;
  }

  function stamp(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll("template[data-deferred-card-media]").forEach(function (tpl) {
      if (!tpl.content || hiddenSearchCopy(tpl)) return;
      tpl.replaceWith(tpl.content);
    });
  }

  function unlock() {
    if (state.unlocked) return;
    state.unlocked = true;
    stamp(document);
    events.forEach(function (type) {
      document.removeEventListener(type, onInteract, true);
    });
  }

  function onInteract(event) {
    if (!event.isTrusted) return;
    unlock();
  }

  events.forEach(function (type) {
    document.addEventListener(type, onInteract, { capture: true, passive: true });
  });

  function stampAdded(node) {
    if (node.matches && node.matches("template[data-deferred-card-media]")) {
      if (node.content && !hiddenSearchCopy(node)) node.replaceWith(node.content);
      return;
    }
    stamp(node);
  }

  var observer = new MutationObserver(function (mutations) {
    if (!state.unlocked) return;
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        stampAdded(node);
      });
    });
  });

  if (document.body) observer.observe(document.body, { childList: true, subtree: true });

  // Style-only: the fallback sets an inline display, it does not add nodes.
  var searchVisibility = new MutationObserver(function (mutations) {
    if (!state.unlocked) return;
    mutations.forEach(function (mutation) {
      var wrap = mutation.target;
      if (window.getComputedStyle(wrap).display === "none") return;
      stamp(wrap);
    });
  });

  document.querySelectorAll(searchWraps).forEach(function (wrap) {
    searchVisibility.observe(wrap, { attributes: true, attributeFilter: ["style"] });
  });
})();
